import { MyProfile } from "@/portals/(shared)/(profile)/MyProfile";

import { ProfileSidebar } from "../../(shared)/(profile)/components/ProfileSidebar";

import { AdminCalendarPreferencesCard } from "./components/AdminCalendarPreferencesCard";
import { AssociatedPracticeCard } from "./components/AssociatedPracticeCard";
import { BasicInfoCard } from "./components/BasicInfoCard";
import { useAdminProfile } from "./api/queries/useAdminProfile";

export function AdminProfile() {
  const { data: profileData, isLoading } = useAdminProfile();

  return (
    <MyProfile
      asideContent={<ProfileSidebar profileData={profileData} />}
      isLoading={isLoading}
      renderMainContent={() => (
        <>
          <BasicInfoCard />
          <AdminCalendarPreferencesCard />
          <AssociatedPracticeCard />
        </>
      )}
    />
  );
}
